export const LOGO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_stripe-api-keys-2/artifacts/fe2272747a92b88e_WhatsApp%20Image%202026-05-15%20at%2012.17.00.jpeg";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1513036191774-b2badb8fcb76?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800";

export const WORKSHOP_IMG =
  "https://images.unsplash.com/photo-1781621462526-fa73886d096d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400";

// Empty = app buttons hidden. Set the store/web link when the app is published.
export const APP_URL = "";

export const CONTACTS = {
  address: "Località Is Arzolas, Zona Art., Via degli Artigiani n. 8, 09170 Narbolia (OR)",
  phone: "345 399 5514",
  phoneHref: "tel:+393453995514",
  email: "tmsgarageauto@gmail.com",
  hours: [["Orario continuato", "07:00 – 14:30"]],
};
